import {
  WHEEL_TRANSECTION_ALL,
  WHEEL_TRANSECTION_GET,
  WHEEL_TRANSECTION_POST,
  WHEEL_TRANSECTION_PUT,
  WHEEL_TRANSECTION_DELETE,
  WHEEL_TRANSECTION_LOADING,
  WHEEL_TRANSECTION_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const wheelTransectionCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: WHEEL_TRANSECTION_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/wheel-transection`,
      {
        ...payload,
      },
    );
    dispatch({ type: WHEEL_TRANSECTION_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEEL_TRANSECTION_ERROR });
  }
};

export const wheelTransectionAll = (params) => async (dispatch) => {
  try {
    const {
      name = '',
      size = '',
      page = 1,
      id = '',
      vehicle = '',
      wms = '',
      trailertail = '',
    } = params;
    console.log('dddd', trailertail);
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/wheel-transection?name=${name}&size=${size}&page=${page}&id=${id}&vehicle=${vehicle}&wms=${wms}&trailertail=${trailertail}`,
    );
    if (status === 200) {
      dispatch({ type: WHEEL_TRANSECTION_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEEL_TRANSECTION_ERROR });
  }
};

export const wheelTransectionGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/wheel-transection/${id}`,
    );
    if (status === 200) {
      dispatch({ type: WHEEL_TRANSECTION_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEEL_TRANSECTION_ERROR });
  }
};

export const wheelTransectionPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: WHEEL_TRANSECTION_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/wheel-transection/${id}`,
      payload,
    );
    dispatch({ type: WHEEL_TRANSECTION_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEEL_TRANSECTION_ERROR });
  }
};
export const wheelTransectionDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: WHEEL_TRANSECTION_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/wheel-transection/${id}`,
    );
    dispatch({ type: WHEEL_TRANSECTION_DELETE, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEEL_TRANSECTION_ERROR });
  }
};
